import AirtableCrud from './AirtableCrud';
import DEFAULT_FIELDS from './default_airtable_fields.json';
import { Airtable as CrmBase } from '@rogoag/airtable/crm';

export { DEFAULT_FIELDS as crmBaseDefaultFields };

const CRM_BASE_ID = import.meta.env.VITE_AIRTABLE_BASE_ID;

export const crmBase = new CrmBase({
  baseId: CRM_BASE_ID,
  apiKey: import.meta.env.VITE_AIRTABLE_API_KEY,
});

export const JOBS_RUN_VIEW_NAME = 'App View - Run Missions';
export const JOBS_COMPLETED_VIEW_NAME = 'App View - Sampled Missions';
export const DROPOFF_VIEW_NAME = 'App View - Scheduled Dropoffs';

// CRM
export const AirtableViewIdLookup = {
  Jobs: {
    [JOBS_RUN_VIEW_NAME]: 'viwAvI4Wr3aSbmggL',
    [JOBS_COMPLETED_VIEW_NAME]: 'viwR528VULoTPzMD0',
  },
  'Shift Dropoffs': {
    [DROPOFF_VIEW_NAME]: 'viwgBFPyCbQdggKiy',
  },
} as const;

const crmCrud = new AirtableCrud(CRM_BASE_ID, import.meta.env.VITE_AIRTABLE_API_KEY, DEFAULT_FIELDS);

Object.freeze(crmCrud);

export { crmCrud };
